import React, {FC, useMemo, useState} from 'react'
import {Card, Card3, TablesWidget14} from '../../../_metronic/partials'
import {DATE_RANGE} from '../../@components'
import {DateRangeType, LoadingState} from '../../../global'
import {GetDriverSteps, usePeriod, useStartDriver, useWebFormsData} from '../../features'
import {RootState} from '../../../setup'
import {getWebFormsCardsConfig} from '../../@constants'
import {shallowEqual, useSelector} from 'react-redux'
import {DriverStateType, useDriver} from '../../@contexts'
import {DEFAULT_DATE_RANGE} from '../../@types/global'

const Dashboard = () => {

    return <Card id={'dashboard_web_forms'} title={'Tableau de bord'} body={<Body />} size={'lg'} />
}

export default Dashboard

const Body: FC = () => {

    const {pages: {webForms}} = useSelector<RootState>(({driver}) => driver, shallowEqual) as DriverStateType
    const {startDriver} = useDriver()
    const [selectedDateRange, setSelectedDateRange] = useState<DateRangeType>(DEFAULT_DATE_RANGE)
    const [loading, setLoading] = useState<LoadingState>('idle')
    const period = usePeriod(selectedDateRange)
    const {data} = useWebFormsData({period, setLoading})
    const handleDateRangeChange = (dateRange: DateRangeType) => {
        setSelectedDateRange(dateRange)
    }
    const cards = useMemo(() => getWebFormsCardsConfig(), [])
    const steps = useMemo(() => GetDriverSteps({cards, page: 'webForms'}), [cards])
    // useStartDriver({
    //     loading,
    //     pageFeatureFlag: webForms,
    //     steps,
    //     pageName: 'webForms',
    //     startDriver,
    // })

    return (
        <div
            className="row g-3 g-xl-10 d-flex justify-content-center align-items-end flex-md-row mb-5">
            <div className="col-12 col-lg-8">
                <div className="row">
                    <div className="col-12 col-lg-4 mb-3 mb-lg-0" id="webForms-step-0">
                        <Card3 bg={0} countUp={data.cards.formsReceived} title={'Formulaires reçus'} />
                    </div>
                    <div className="col-12 col-lg-4 mb-3 mb-lg-0" id="webForms-step-1">
                        <Card3 bg={1} countUp={data.cards.formsProcessed} title={'Formulaires traités'} />
                    </div>
                    <div className="col-12 col-lg-4 mb-3 mb-lg-0" id="webForms-step-2">
                        <Card3 bg={0} countUp={data.cards.responseRate} title={'Taux de réponse'} />
                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-4 d-flex justify-content-end align-items-end mb-5 mb-md-0">
                <DATE_RANGE onDateRangeChange={handleDateRangeChange} loading={loading} setLoading={setLoading} />
            </div>
            <div id="webForms-step-3">
                <TablesWidget14 data={data} />
            </div>
        </div>
    )
}